import { useEffect, useState } from "react";
import headerLeftLogo from "../../../headerLeftLogo.png"
import headerRightLogo from "../../../headerRightLogo.png"
import footerImage from "../../../footerImage.png"
import headerImage from "../../../headerFullImage.png"
import "./OrderPDFNewCommonStyleSheet.scss";
import FetchData, { GetOne } from "../../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import { CheckNull, PriceFormat, formatDate, numberToWords, FormatValueDecimal, getStorageData, calculateNetPrice } from "../../../utils/Validate";
import { ConvertFromBase } from "../../../utils/Validate";
import moment from "moment";
import NewTermsAndConditions from "./NewTermsAndConditions";

const OrderPDFNewSummary = () => {
    const [totalPages, setTotalPages] = useState(1);

    const location = useLocation();
    const [customerObj, setCustomer] = useState(null);
    const [orderPDFDetails, setOrderPDFDetails] = useState(null);
    const [projectObj, setProject] = useState(null);
    const [distributorImage, setDistributorImage] = useState(null);
    const [listData, setListData] = useState([])
    let totalDdp = 0;
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("id");

    const { data: currencyList } = FetchData("currency");
    const { data: assignedEngineerList } = FetchData("userprofile");
    const { data: deliveryTermsList } = FetchData("deliveryterms");
    const { data: paymentTermsList } = FetchData("paymentterms");
    const { data: countryList } = FetchData("country");
    const { data: distributorList } = FetchData("distributor");

    const displayDetails = orderPDFDetails?.data;
    const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == displayDetails?.salesEngineerId)
    const currencyDetail = currencyList?.find(item => item?.id === displayDetails?.currencyId)

    const orderDistributor = distributorList?.find(item => item?.id === displayDetails?.distributorId);
    const baseCurrency = currencyList?.find(item => item?.id === orderDistributor?.currencyId);

    const CurrencyConvertion = (amount, rate, currency) =>
        ConvertFromBase(amount, rate, currency, baseCurrency);
    // Use the order's own item totalPrice (same source as the Detail PDF); fall back to calculateNetPrice only if missing.
    const getItemNetPrice = (item) => {
        const hasTotals = item?.productItems?.some(p => p?.totalPrice !== undefined && p?.totalPrice !== null);
        if (hasTotals) {
            return item.productItems.reduce((sum, p) => sum + (Number(p?.totalPrice) || 0), 0);
        }
        return calculateNetPrice(item);
    };

    const totalNetPrice = parseFloat(
        (displayDetails?.products?.reduce((sum, item) => sum + getItemNetPrice(item), 0) || 0).toFixed(2)
    );

    useEffect(() => {
        if (orderId) {
            GetOne("order", { id: orderId }, setOrderPDFDetails);
        }
    }, [orderId]);

    useEffect(() => {
        if (displayDetails) {
            GetOne("Customer", { id: displayDetails?.customerId }, setCustomer);
            GetOne("project", { id: displayDetails?.projectId }, setProject);
        }
    }, [displayDetails])

    useEffect(() => {
        if (salesEngObj?.id) {
            GetOne("userprofile", { id: salesEngObj?.id }, setListData)
        }
    }, [salesEngObj]);


    useEffect(() => {
        const userProf = getStorageData();
        const userProfId = userProf?.userCompanyId;
        const distributorUrl = distributorList?.find(item => item?.id === userProfId)
        setDistributorImage({ distributorUrl: distributorUrl, userProf: userProf })
    }, [distributorList])

    useEffect(() => {
        const updatePageNumbers = () => {
            const total = Math.ceil(document.body.scrollHeight / window.innerHeight);
            setTotalPages(total);
        };

        window.addEventListener("resize", updatePageNumbers);
        updatePageNumbers();

        return () => window.removeEventListener("resize", updatePageNumbers);
    }, []);

    const specialCharges = Number(orderPDFDetails?.data?.specialCharges) || 0;
    const taxableAmount = totalNetPrice + specialCharges;

    const taxAmount = (() => {
        const data = displayDetails;
        if (!data) return 0;
        if (data?.tax > 0) return data.tax * 1;
        if (data?.taxPercentage > 0) return taxableAmount * (data.taxPercentage / 100);
        return 0;
    })();

    const grandTotal = parseFloat((taxableAmount + taxAmount).toFixed(2));
    const showTaxRow = displayDetails?.tax > 0 || displayDetails?.taxPercentage > 0;
    const showGrandTotalRow = grandTotal > 0;
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12 text-end">
                        <div className="print-btn-container">
                            <button onClick={() => window.print()} className="btn pdf-print-btn my-2">Export to PDF</button>
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="bg-white">
                            <thead>
                                <tr>
                                    <td className="boder-none p-0">
                                        <div className="page-header position-relative">
                                            <table className="quotation-summary-pdf-table-head w-100">
                                                <tr>
                                                    <th className="text-start pt-0 pl-0 position-relative">
                                                        <img className="w-100" src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.headerUrl : headerImage} />
                                                        <div className="quotation-text">ORDER</div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </thead>

                            <tbody className="page-content">
                                <tr>
                                    <td className="boder-none">
                                        <div className="page">
                                            <table className="customer-details-table">
                                                <tbody>
                                                    <tr>
                                                        <td className="w-50 border-right">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Customer <span className="float-right">:</span></td>
                                                                        <td>{customerObj?.data?.customerName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Address <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.customerAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact Person <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.contactPerson}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact # <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>

                                                        {/* Second Column (Order Details) */}
                                                        <td className="w-50">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Order Ref <span className="float-right">:</span></td>
                                                                        <td>{orderPDFDetails?.data?.orderReference}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Date <span className="float-right">:</span></td>
                                                                        <td>{formatDate(displayDetails?.createdAt, "")}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Email <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.emailAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Sales Eng <span className="float-right">:</span></td>
                                                                        <td>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact <span className="float-right">:</span></td>
                                                                        <td>{listData?.data?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-top" colspan="2">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="w-12">Project<span className="float-right">:</span></td>
                                                                        <td colspan="4">{projectObj?.data?.projectName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> Dear Sir/Madam, <br />
                                                            We thank you for your enquiry and are pleased to submit our proposal as follows:
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="product-details-table w-100">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th className="border-right">Product Group</th>
                                                        <th className="border-right text-center">Model</th>
                                                        <th className="border-right text-center">Qty</th>
                                                        <th className="text-center w-15">Total Price ({currencyDetail?.shortCode})</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        displayDetails?.products?.map((item, index) => {
                                                            const itemNetPrice = getItemNetPrice(item);
                                                            totalDdp = ((totalDdp || 0) * 1) + itemNetPrice
                                                            return (
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td className="border-right">{item?.groupName}</td>
                                                                    <td className="border-right text-center"> {item?.productName}</td>
                                                                    <td className="border-right text-center">{item?.quoteQuantity ?? item?.currentOrderQuantity}</td>
                                                                    <td className="text-right">
                                                                        {FormatValueDecimal(
                                                                            CurrencyConvertion(itemNetPrice, displayDetails?.conversionRate, currencyDetail)
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                            <table className="net-price-table w-100 mt-5px">
                                                <tbody>
                                                    <tr>
                                                        <td className="quote-amount-words">
                                                            <strong className="quote-amount-words-title">Amount in words</strong>
                                                            <span className="quote-amount-words-value">{numberToWords(CurrencyConvertion(grandTotal, displayDetails?.conversionRate, currencyDetail), currencyDetail)}</span>
                                                        </td>
                                                        <td className="quote-summary-cell">
                                                            <table className="quote-summary-inner">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="quote-summary-item">
                                                                            <span>Net Price</span><span className="ml-1">:</span>
                                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(totalNetPrice, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>
                                                                    {specialCharges > 0 && (
                                                                        <tr>
                                                                            <td className="quote-summary-item">
                                                                                <span>Color Charges</span><span className="ml-1">:</span>
                                                                                <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(specialCharges, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {showTaxRow && (<tr>
                                                                        <td className="quote-summary-item">
                                                                            <span>Taxes / VAT {displayDetails?.tax > 0 ? "" : "@ " + displayDetails?.taxPercentage + "%"}</span><span className="ml-1">:</span>
                                                                            <span>{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(taxAmount, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>)}
                                                                    {showGrandTotalRow && (<tr>
                                                                        <td className="quote-summary-item quote-summary-item--grand">
                                                                            <span>Grand Total</span><span className="ml-1">:</span>
                                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(grandTotal, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>)}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="terms-conditions-table w-100 mt-5px border-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start" colspan="2"> Terms & Conditions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start">Payment Terms
                                                            <span className="float-right">:</span>
                                                        </td>
                                                        <td className="text-start">{displayDetails?.paymentTerms || paymentTermsList?.find(item => item?.id === displayDetails?.paymentTermId)?.paymentDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Terms <span className="float-right">:</span></td>
                                                        <td className="text-start">{displayDetails?.deliveryTerms || deliveryTermsList?.find(item => item?.id === displayDetails?.deliveryTermId)?.deliveryDescription
                                                            || displayDetails?.destination}
                                                            {countryList?.find(country => country?.id === displayDetails?.destinationCountryId)?.name
                                                                && (countryList?.find(country => country?.id === displayDetails?.destinationCountryId)?.name)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Period <span className="float-right">:</span></td>
                                                        <td className="text-start">As per the project requirement</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Validity <span className="float-right">:</span></td>
                                                        <td className="text-start"> {displayDetails?.quoteValidity} days from the date hereof and thereafter subject to our written
                                                            confirmation.</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Warranty <span className="float-right">:</span></td>
                                                        <td className="text-start"> Goods manufactured by Jersey Manufacturing carry a standard warranty of 12
                                                            months from the date of supply,
                                                            against all manufacturing defects, subject to our warranty policy - (can be provided on
                                                            request).</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> We once again thank you for the opportunity to order for your requirement. Please feel free to contact us in case of any clarification. <br />
                                                            Thanking you and assuring you our best attention and services at all times.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-0 py-1 fs-13"> For, Jersey Manufacturing for Airconditioning Products
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="signature-table w-100 mt-1 mb-1 border-0 mt-5">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center border-0"> Sales Engineer
                                                        </td>
                                                        <td className="text-center border-0">  Divisional manager</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0 pb-0">
                                        <div className="page-footer-space"></div>
                                        <div className="page-quote-footer w-100">
                                            <table className="footer-quote-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start border-0 pl-0">Order Ref # : {orderPDFDetails?.data?.orderReference}</td>
                                                        <td className="text-end border-0">{moment(new Date()).format("DD-MMM-YYYY hh:mm A")}</td>
                                                        <td className="text-end border-0 pr-40">QR/DR-N/2021 RDO</td>
                                                        {/* <td className="text-end border-0 pr-40">Page 1 of 15</td>  */}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0">
                                        <div className="page-footer w-100">
                                            <table className="footer-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr className="border-top">
                                                        <th className="text-start pl-0 pr-0 border-0 pt-0 pb-0" colSpan="9">
                                                            <img src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.footerUrl : footerImage} alt="Footer Logo" className="footer-logo w-100" />
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <NewTermsAndConditions distributorImage={distributorImage} />
        </>
    );
};

export default OrderPDFNewSummary;
